module.exports = __webpack_public_path__ + "static/media/germanantitank1942east.085e0f18.jpg";